// extracted by mini-css-extract-plugin
module.exports = {"profile":"Profile-module__profile___4Z95A","profileContent":"Profile-module__profileContent___3jz-1","mobileScrollName":"Profile-module__mobileScrollName___31tyx"};